import { Type } from '../actions/resources/ImplementsActions';

const createEmptyImplement = () => ({
    id: null,
    naziv: '',
    sifra: '',
    id_prikljucna_masina_grupa: '',
    id_prikljucna_masina_podgrupa: ''
});

const initialState = {
    implementGroupDropdown: [],
    implementSubgroupDropdown: [],
    implementObj: createEmptyImplement(),
    groupFetching: false,
    groupFetchingFailed: false,
    subgroupFetching: false,
    subgroupFetchingFailed: false,
    implementsPosting: false,
    implementsPostingSuccess: false,
    implementsPostingFailed: false,
    deleteImplementing: false,
    deleteImplementSuccess: false,
    deleteImplementFailed: false
};

export default function implementReducer(state = initialState, action) {
    switch (action.type) {
        case Type.GET_IMPLEMENT_GROUP_CALL:
            return {
                ...state,
                groupFetching: true,
                groupFetchingFailed: false
            };
        case Type.GET_IMPLEMENT_GROUP_SUCCESS:
            return {
                ...state,
                implementGroupDropdown: action.data || [],
                groupFetching: false
            };
        case Type.GET_IMPLEMENT_GROUP_FAILED:
            return {
                ...state,
                groupFetching: false,
                groupFetchingFailed: true
            };
        case Type.GET_IMPLEMENT_SUBGROUP_CALL:
            return {
                ...state,
                subgroupFetching: true,
                subgroupFetchingFailed: false
            };
        case Type.GET_IMPLEMENT_SUBGROUP_SUCCESS:
            return {
                ...state,
                implementSubgroupDropdown: action.data || [],
                subgroupFetching: false
            };
        case Type.GET_IMPLEMENT_SUBGROUP_FAILED:
            return {
                ...state,
                subgroupFetching: false,
                subgroupFetchingFailed: true
            };
        case Type.ADD_IMPLEMENT_CALL:
            return {
                ...state,
                implementsPosting: true,
                implementsPostingSuccess: false,
                implementsPostingFailed: false
            };
        case Type.ADD_IMPLEMENT_SUCCESS:
            return {
                ...state,
                implementsPosting: false,
                implementsPostingSuccess: true,
                implementObj: createEmptyImplement()
            };
        case Type.ADD_IMPLEMENT_FAILED:
            return {
                ...state,
                implementsPosting: false,
                implementsPostingFailed: true
            };
        case Type.DELETE_IMPLEMENT_CALL:
            return {
                ...state,
                deleteImplementing: true,
                deleteImplementSuccess: false,
                deleteImplementFailed: false
            };
        case Type.DELETE_IMPLEMENT_SUCCESS:
            return {
                ...state,
                deleteImplementing: false,
                deleteImplementSuccess: true
            };
        case Type.DELETE_IMPLEMENT_FAILED:
            return {
                ...state,
                deleteImplementing: false,
                deleteImplementFailed: true
            };
        case Type.SET_IMPLEMENT_OBJ:
            return {
                ...state,
                implementObj: action.data ? { ...action.data } : createEmptyImplement()
            };
        case Type.SET_INITIAL_STATE:
            switch (action.data) {
                case 'implementsPostingSuccess':
                    return { ...state, implementsPostingSuccess: false };
                case 'implementsPostingFailed':
                    return { ...state, implementsPostingFailed: false };
                case 'deleteImplementSuccess':
                    return { ...state, deleteImplementSuccess: false };
                case 'deleteImplementFailed':
                    return { ...state, deleteImplementFailed: false };
                default:
                    return state;
            }
        default:
            return state;
    }
}
